(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    document.querySelectorAll("[data-mp-header]:not([data-mp-ready])").forEach((header) => {
      header.dataset.mpReady = "true";
      const spacer = document.querySelector("[data-mp-header-spacer]");

      // ---- Mobile menu -------------------------------------------------
      // The panel uses [hidden] for the closed resting state so it is out of
      // the accessibility tree, and a data-state attribute for the animation.
      // Opening removes [hidden] first, then flips the state on the next
      // frame, otherwise the browser has nothing to transition FROM.
      const burger = header.querySelector("[data-mp-burger]");
      const panel = header.querySelector("[data-mp-menu]");
      if (burger && panel) {
        let open = false;
        let closeTimer = null;

        const setOpen = (next) => {
          if (next === open) return;
          open = next;
          burger.setAttribute("aria-expanded", String(open));
          if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
          if (open) {
            panel.hidden = false;
            panel.dataset.mpState = "closed";
            requestAnimationFrame(() => requestAnimationFrame(() => {
              panel.dataset.mpState = "open";
            }));
          } else {
            panel.dataset.mpState = "closed";
            // Keep it in the DOM until the collapse finishes, then hide it.
            closeTimer = setTimeout(() => {
              if (!open) panel.hidden = true;
              closeTimer = null;
            }, 300);
          }
        };

        burger.addEventListener("click", (e) => { e.stopPropagation(); setOpen(!open); });
        // Navigating away still fires the close so the icon is never left as an X.
        panel.addEventListener("click", (e) => {
          if (e.target.closest("a")) setOpen(false);
        });
        document.addEventListener("click", (e) => {
          if (open && !header.contains(e.target)) setOpen(false);
        });
        document.addEventListener("keydown", (e) => {
          if (e.key === "Escape" && open) { setOpen(false); burger.focus(); }
        });
        // Rotating to landscape can cross the breakpoint; the panel is
        // display:none above it, so leaving it open would strand the state.
        window.addEventListener("resize", () => {
          if (open && window.innerWidth >= 750) setOpen(false);
        });
      }
      // Resolve the hero lazily. The header section renders BEFORE the hero
      // section, so a one-time querySelector here always returned null and
      // every page loaded in the opaque "scrolled" state instead of merging
      // into the hero. Re-querying until it is found fixes the ordering.
      let hero = document.querySelector("[data-mp-hero]");
      const findHero = () => (hero = hero || document.querySelector("[data-mp-hero]"));

      // Pages with no hero need a spacer, or the fixed dock covers the content.
      const setSpacer = () => {
        if (!spacer) return;
        if (hero) { spacer.hidden = true; return; }
        spacer.hidden = false;
        spacer.style.setProperty("--mp-dock-h", Math.round(header.getBoundingClientRect().height) + "px");
      };

      const setState = (atTop) => {
        const transparent = Boolean(findHero()) && atTop;
        header.classList.toggle("is-transparent", transparent);
        header.classList.toggle("is-scrolled", !transparent);
        header.classList.remove("is-over-hero");
      };

      // Primary: a sentinel watched by IntersectionObserver. This does not
      // depend on scroll events being delivered, which some embedded and
      // in-app browsers throttle or drop entirely.
      let usedObserver = false;
      if (hero && "IntersectionObserver" in window) {
        const sentinel = document.createElement("div");
        sentinel.setAttribute("data-mp-header-sentinel", "");
        sentinel.style.cssText =
          "position:absolute;top:0;left:0;width:1px;height:40px;pointer-events:none;visibility:hidden";
        document.body.insertBefore(sentinel, document.body.firstChild);
        new IntersectionObserver((entries) => {
          entries.forEach((e) => setState(e.isIntersecting));
        }, { threshold: 0 }).observe(sentinel);
        usedObserver = true;
      }

      // Fallback for no-hero pages and any browser without IO.
      let ticking = false;
      const onScroll = () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(() => { setState(window.scrollY < 40); ticking = false; });
      };
      // Always attach the scroll listener too. IO and scroll events are each
      // dropped by some embedded browsers; together, one of them always lands.
      window.addEventListener("scroll", onScroll, { passive: true });
      void usedObserver;

      window.addEventListener("resize", () => { setSpacer(); });
      if ("ResizeObserver" in window) {
        new ResizeObserver(() => setSpacer()).observe(header);
      }
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(setSpacer);
      }
      setSpacer();
      // Run once now, then again once the rest of the page (including the
      // hero) has parsed, so the merged/transparent state is correct on load
      // rather than only after the first scroll.
      const sync = () => { findHero(); setSpacer(); setState(window.scrollY < 40); };
      sync();
      if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", sync, { once: true });
      }
      window.addEventListener("load", sync, { once: true });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-animated-text"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-platform-hero]:not([data-platform-hero-ready])').forEach((hero) => {
      hero.dataset.platformHeroReady = 'true';
      const scene = hero.querySelector('.platform-hero__scene');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (!scene || reducedMotion.matches) return;

      if ('IntersectionObserver' in window) {
        new IntersectionObserver((entries) => {
          hero.classList.toggle('is-motion-paused', !entries[0].isIntersecting);
        }, { threshold: 0.1 }).observe(hero);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["interactive-specs"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('.interactive-specs:not([data-ready])').forEach((section) => {
      section.dataset.ready = 'true';
      const tabs = section.querySelectorAll('[data-specs-tab]');
      const panels = section.querySelectorAll('[data-specs-panel]');
      const selectTab = (tab, shouldFocus) => {
        const target = tab.dataset.specsTab;
        tabs.forEach((item) => {
          const selected = item === tab;
          item.setAttribute('aria-selected', selected ? 'true' : 'false');
          item.tabIndex = selected ? 0 : -1;
        });
        panels.forEach((panel) => { const active = panel.dataset.specsPanel === target; panel.hidden = !active; panel.classList.toggle('is-active', active); });
        if (shouldFocus) tab.focus({ preventScroll: true });
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => selectTab(tab, false));
        tab.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight' && event.key !== 'Home' && event.key !== 'End') return;
          event.preventDefault();
          let nextIndex = index;
          if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = tabs.length - 1;
          selectTab(tabs[nextIndex], true);
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["live-asset-grid"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-live-asset-grid]:not([data-ready])').forEach((grid) => {
      grid.dataset.ready = 'true';
      const tabs = grid.querySelectorAll('[data-asset-tab]');
      const panels = grid.querySelectorAll('[data-asset-panel]');
      const selectTab = (tab, shouldFocus) => {
        const target = tab.dataset.assetTab;
        tabs.forEach((item) => {
          const selected = item === tab;
          item.setAttribute('aria-selected', selected ? 'true' : 'false');
          item.tabIndex = selected ? 0 : -1;
        });
        panels.forEach((panel) => { panel.hidden = panel.dataset.assetPanel !== target; });
        if (shouldFocus) tab.focus({ preventScroll: true });
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => selectTab(tab, false));
        tab.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight' && event.key !== 'Home' && event.key !== 'End') return;
          event.preventDefault();
          let nextIndex = index;
          if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = tabs.length - 1;
          selectTab(tabs[nextIndex], true);
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pulp-brand-promise"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-pulp-promise]:not([data-pulp-promise-ready])').forEach((section) => {
      section.dataset.pulpPromiseReady = 'true';
      const words = section.dataset.promiseWords.split('|').map((word) => word.trim()).filter(Boolean);
      const word = section.querySelector('[data-promise-word]');
      const motionWord = section.querySelector('[data-promise-motion-word]');
      if (words.length < 2 || !word || !motionWord || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      let index = 0;
      let timer;
      let inView = true;
      let paused = false;
      const stop = () => {
        window.clearInterval(timer);
        timer = undefined;
      };
      const start = () => {
        if (timer || paused || !inView) return;
        timer = window.setInterval(() => {
          word.classList.add('is-changing');
          window.setTimeout(() => {
            index = (index + 1) % words.length;
            word.textContent = words[index];
            motionWord.textContent = words[index];
            word.classList.remove('is-changing');
          }, 180);
        }, 2800);
      };
      const sync = () => {
        stop();
        start();
      };

      section.addEventListener('mouseenter', () => {
        paused = true;
        stop();
      });
      section.addEventListener('mouseleave', () => {
        paused = false;
        start();
      });
      section.addEventListener('focusin', () => {
        paused = true;
        stop();
      });
      section.addEventListener('focusout', () => {
        paused = false;
        start();
      });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver((entries) => {
          inView = entries[0].isIntersecting;
          sync();
        }, { threshold: 0.25 }).observe(section);
      }
      start();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
